"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var constants_1 = require("./constants");

var delayDecider_1 = require("./delayDecider");

var retryDecider_1 = require("./retryDecider");

var service_error_classification_1 = require("@aws-sdk/service-error-classification");

var ExponentialBackOffStrategy =
/** @class */
function () {
  function ExponentialBackOffStrategy(maxRetries, retryDecider, delayDecider) {
    if (retryDecider === void 0) {
      retryDecider = retryDecider_1.defaultRetryDecider;
    }

    if (delayDecider === void 0) {
      delayDecider = delayDecider_1.defaultDelayDecider;
    }

    this.maxRetries = maxRetries;
    this.retryDecider = retryDecider;
    this.delayDecider = delayDecider;
  }

  ExponentialBackOffStrategy.prototype.shouldRetry = function (error, retryAttempted) {
    return retryAttempted < this.maxRetries && this.retryDecider(error);
  };

  ExponentialBackOffStrategy.prototype.retry = function (next, args) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var retries, totalDelay, _loop_1, this_1, state_1;

      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            retries = 0;
            totalDelay = 0;

            _loop_1 = function _loop_1() {
              var _a, response, output, err_1, delay_1;

              return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _b.trys.push([0, 2,, 5]);

                    return [4
                    /*yield*/
                    , next(args)];

                  case 1:
                    _a = _b.sent(), response = _a.response, output = _a.output;
                    output.$metadata.retries = retries;
                    output.$metadata.totalRetryDelay = totalDelay;
                    return [2
                    /*return*/
                    , {
                      value: {
                        response: response,
                        output: output
                      }
                    }];

                  case 2:
                    err_1 = _b.sent();
                    if (!this_1.shouldRetry(err_1, retries)) return [3
                    /*break*/
                    , 4];
                    delay_1 = this_1.delayDecider(service_error_classification_1.isThrottlingError(err_1) ? constants_1.THROTTLING_RETRY_DELAY_BASE : constants_1.DEFAULT_RETRY_DELAY_BASE, retries++);
                    totalDelay += delay_1;
                    return [4
                    /*yield*/
                    , new Promise(function (resolve) {
                      return setTimeout(resolve, delay_1);
                    })];

                  case 3:
                    _b.sent();

                    return [2
                    /*return*/
                    , "continue"];

                  case 4:
                    if (!err_1.$metadata) {
                      err_1.$metadata = {};
                    }

                    err_1.$metadata.retries = retries;
                    err_1.$metadata.totalRetryDelay = totalDelay;
                    throw err_1;

                  case 5:
                    return [2
                    /*return*/
                    ];
                }
              });
            };

            this_1 = this;
            _a.label = 1;

          case 1:
            if (!true) return [3
            /*break*/
            , 3];
            return [5
            /*yield**/
            , _loop_1()];

          case 2:
            state_1 = _a.sent();
            if (typeof state_1 === "object") return [2
            /*return*/
            , state_1.value];
            return [3
            /*break*/
            , 1];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return ExponentialBackOffStrategy;
}();

exports.ExponentialBackOffStrategy = ExponentialBackOffStrategy;